import { EMMA_EVENTS } from '../constants';
import { AppEvent } from '../models/events.model';

/** @deprecated i18n does not work this way */
const eventLabels: { [k: string]: string } = {
  [EMMA_EVENTS.AUTO_EVENT]: 'Evento automático',
  [EMMA_EVENTS.END_SESSION]: 'Fin sesión',
  [EMMA_EVENTS.FIRST_LOGIN]: 'Primer login',
  [EMMA_EVENTS.INSTALL]: 'Instalación',
  [EMMA_EVENTS.LOGIN]: 'Login',
  [EMMA_EVENTS.REGISTER]: 'Registro',
  [EMMA_EVENTS.SESSION]: 'Sesión',
  [EMMA_EVENTS.TRANSACTION]: 'Venta',
};

/** @deprecated */
export const getEventLabelByToken = (i18n: any = (s: string) => s, token: string, altName = '') => {
  return i18n(eventLabels[token] || altName || token);
};

/** @deprecated */
export const getEventLabelByName = (i18n: any = (s: string) => s, name: keyof typeof EMMA_EVENTS) => {
  const token = EMMA_EVENTS[name];
  if (!token) {
    return i18n(name);
  } else {
    return i18n(eventLabels[token] || name);
  }
};

/** @deprecated */
export const parseEvents = (i18n: any = (s: string) => s, events: AppEvent[]) => {
  return events.map((ev) => ({
    ...ev,
    __label: getEventLabelByToken(i18n, ev.token, ev.name),
  }));
};
